import { Tabs } from "../../shared";
import VeevaConfigForm from "./VeevaConfigForm";
import ViewVeevaConfig from "./ViewVeevaConfig";
import { UPDATE_VEEVA_CONFIG } from "./query";
const SubComponent = ({ data }) => {
    const { id } = data;

    return (
        <Tabs
            tabItems={[
                {
                    id: `viewConfig${data.id}`,
                    name: "View",
                    content: <ViewVeevaConfig data={data} />,
                },
                {
                    id: `updateConfig${id}`,
                    name: "Update",
                    content: (
                        <>
                            <h5 className="mb-4">Update Veeva</h5>
                            <VeevaConfigForm
                                query={UPDATE_VEEVA_CONFIG}
                                formType="update"
                                formData={data}
                            />
                        </>
                    ),
                },
            ]}
        />
    );
};

export default SubComponent;
